<div
  class="d-flex align-items-center"
  [ngClass]="{ 'mr-3': !smallNav() }"
>
  <app-portfolio-icon [portfolioName]="userLogo"></app-portfolio-icon>
  <div class="h-100 ml-2">
    <div
      class="btn-group"
      dropdown
    >
      <button
        dropdownToggle
        type="button"
        class="btn btn-link dropdown-toggle font-size-normal text-primary pl-0 pt-0 pb-1"
      >
        @if (!smallNav()) {
          <span class="font-weight-bold">{{ userName }}</span>
        }
        <span class="caret"></span>
      </button>
      <ul
        *dropdownMenu
        class="dropdown-menu dropdown-menu-right contains-modal"
        role="menu"
      >
        <li
          role="menuitem"
          (click)="goToSettings()"
        >
          <a href="javascript:void(0)">
            <div class="dropdown-item text-left font-weight-bold">
              <i class="far fa-cog mr-1"></i>
              Settings
            </div>
          </a>
        </li>
        <div class="dropdown-divider m-0"></div>
        <li role="menuitem">
          <a href="javascript:void(0)">
            <div
              class="dropdown-item text-left font-weight-bold"
              (click)="openConfirmationModal()"
            >
              <i class="fa fa-sign-out-alt mr-1"></i>
              {{ 'HEADER.LOGOUT' | translate }}
            </div>
          </a>
        </li>
        @if (smallNav()) {
          <div class="dropdown-divider m-0"></div>
          <li role="menuitem">
            <div class="d-flex justify-content-center my-2">
              <lib-theme-switch></lib-theme-switch>
            </div>
          </li>
        }
      </ul>
    </div>
    @if (!smallNav()) {
      <div class="font-size-small text-primary">{{ role }}</div>
    }
  </div>
</div>

<ng-template #confirmationModal>
  <div class="card">
    <div class="modal-header border-bottom-0 pb-0">
      <button
        type="button"
        class="close text-right text-primary"
        (click)="closeConfirmationModal()"
      >
        <span>&times;</span>
      </button>
    </div>
    <div class="d-flex p-3">
      <p class="text-primary font-weight-bold mx-auto font-size-small text-center">Do you really want to logout?</p>
    </div>
    <div class="mx-auto mb-4">
      <lib-button
        class="logout-confirm"
        [size]="'medium'"
        [color]="'primary'"
        [label]="'Logout'"
        (buttonClicked)="logout()"
      ></lib-button>
    </div>
  </div>
</ng-template>
